import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import * as fromDocumentTypes from './doc-admin-reducer';
import { DocumentTypeEffects } from './effects';
import { EnvironmentProviders } from '@angular/core';

export const provideDocAdminStore = (): EnvironmentProviders[] => [
    provideState(fromDocumentTypes.documentTypesFeatureKey, fromDocumentTypes.reducer),
    provideEffects(DocumentTypeEffects)
];
